import { render } from "./PharmacistCertifications.vue?vue&type=template&id=4a1e83fa"
import script from "./PharmacistCertifications.vue?vue&type=script&lang=js"
export * from "./PharmacistCertifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__